export const flattenDataProviders = providers => {
  return providers.map(({ key }) => key);
};

export default flattenDataProviders;

export const ACTIVATION_REQUIRED_ACCOUNT_LABEL = 'Compte pub';
export const ACTIVATION_REQUIRED_PAGE_LABEL = 'Page';

export const ACTIVATION_REQUIRED_FIELD_OPTIONS = [
  {
    key: ACTIVATION_REQUIRED_ACCOUNT_LABEL,
    label: ACTIVATION_REQUIRED_ACCOUNT_LABEL
  },
  {
    key: ACTIVATION_REQUIRED_PAGE_LABEL,
    label: ACTIVATION_REQUIRED_PAGE_LABEL
  }
];

const buildRequiredFields = row => {
  const requiredFields = [];

  if (row?.account) {
    requiredFields.push({
      key: ACTIVATION_REQUIRED_ACCOUNT_LABEL,
      label: ACTIVATION_REQUIRED_ACCOUNT_LABEL
    });
  }

  if (row?.page) {
    requiredFields.push({
      key: ACTIVATION_REQUIRED_PAGE_LABEL,
      label: ACTIVATION_REQUIRED_PAGE_LABEL
    });
  }

  return requiredFields;
};

const hasRequiredField = (requiredFields, key) => {
  const hasField = requiredFields.some(field => {
    return field?.key === key;
  });

  return hasField;
};

export const mapActivationRequiredMediaConfigsFromConfig = value => {
  const rows = Array.isArray(value) ? value : [];

  return rows.reduce((acc, row) => {
    acc.push({
      media: row?.media || '',
      requiredFields: buildRequiredFields(row),
      tuto: !!row?.tuto
    });

    return acc;
  }, []);
};

export const formatActivationRequiredMediaConfigs = value => {
  const rows = Array.isArray(value) ? value : [];

  return rows.reduce((acc, row) => {
    const media = row?.media || '';
    const requiredFields = Array.isArray(row?.requiredFields)
      ? row.requiredFields
      : [];

    if (!media) {
      return acc;
    }

    acc.push({
      media,
      account: hasRequiredField(
        requiredFields,
        ACTIVATION_REQUIRED_ACCOUNT_LABEL
      ),
      page: hasRequiredField(requiredFields, ACTIVATION_REQUIRED_PAGE_LABEL),
      tuto: !!row?.tuto
    });

    return acc;
  }, []);
};

export const mapActivableMediaAutomationConfigsFromConfig = (
  value,
  mediaCatalog = []
) => {
  const rows = Array.isArray(value) ? value : [];
  const labelByKey = (Array.isArray(mediaCatalog) ? mediaCatalog : []).reduce(
    (acc, media) => {
      acc[media.key] = media.name;
      return acc;
    },
    {}
  );

  return rows.reduce((acc, row) => {
    const media = row?.activableMedia || '';

    if (!media) {
      return acc;
    }

    acc.push({
      activableMedias: [{ key: media, label: labelByKey[media] || media }],
      setupAuto: !!row?.setupAuto,
      activeByDefault: !!row?.activeByDefault
    });

    return acc;
  }, []);
};

export const formatActivableMediaAutomationConfigs = value => {
  const rows = Array.isArray(value) ? value : [];
  const seenMedias = new Set();

  return rows.reduce((acc, row) => {
    const medias = Array.isArray(row?.activableMedias)
      ? row.activableMedias
      : [];

    medias.forEach(media => {
      const mediaKey = media?.key ?? media?.value ?? media;

      if (!mediaKey || seenMedias.has(mediaKey)) {
        return;
      }

      seenMedias.add(mediaKey);

      acc.push({
        activableMedia: mediaKey,
        setupAuto: !!row?.setupAuto,
        activeByDefault: !!row?.activeByDefault
      });
    });

    return acc;
  }, []);
};

export const normalizeActivationRequiredMediaConfigs = entries => {
  const rows = Array.isArray(entries) ? entries : [];

  const normalizedEntries = rows.reduce((acc, row) => {
    const media = row?.media || '';

    if (!media) {
      return acc;
    }

    acc.push({
      media,
      account: !!row?.account,
      page: !!row?.page,
      tuto: !!row?.tuto
    });

    return acc;
  }, []);

  normalizedEntries.sort((a, b) => {
    return a.media.localeCompare(b.media);
  });

  return normalizedEntries;
};
